export class Assunto{
    AssuntoID: number;
    Descricao: string;
}